<p-table [value]="unions" [selection]="unions" (selectionChange)="selectionChangedEvent($event)"
  [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10, 50, 100]"
  [tableStyle]="{'table-layout': 'fixed', 'width': '100%'}" styleClass="p-datatable-striped">
  <ng-template pTemplate="header">
    <tr>
      <th class="dark-blue" style="width: 1rem; border-top: #E7F4FF solid 1px; border-bottom: #E7F4FF solid 1px;">
        #
      </th>
      <th class="dark-blue"
        style="width: 35%; border-top: #E7F4FF solid 1px; border-bottom: #E7F4FF solid 1px; padding: 10px 0 10px 0;">
        Nom complet
      </th>
      <th class="dark-blue"
        style="width: 10%; border-top: #E7F4FF solid 1px; border-bottom: #E7F4FF solid 1px; padding: 10px 0 10px 0;">
        Nom court
      </th>
      <th class="dark-blue"
        style="width: 20%; border-top: #E7F4FF solid 1px; border-bottom: #E7F4FF solid 1px; padding: 10px 0 10px 0;">
        Collège
      </th>
      <th class="dark-blue"
        style="width: 10%; border-top: #E7F4FF solid 1px; border-bottom: #E7F4FF solid 1px; padding: 10px 0 10px 0;">
        Logo
      </th>
      <th class="dark-blue"
        style="width: 10%; border-top: #E7F4FF solid 1px; border-bottom: #E7F4FF solid 1px; padding: 10px 0 10px 0;">
        PJ
      </th>
      <th class="dark-blue" style="width: 1rem; border-top: #E7F4FF solid 1px; border-bottom: #E7F4FF solid 1px; padding: 10px 0 10px 0;">
        Actions
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-union let-rowIndex="rowIndex">
    <tr [ngClass]="{'bg-light-gray': rowIndex % 2 === 0}">
      <td class="flex content-center dark-blue" style="padding: 5px 0 5px 0;">
        {{rowIndex + 1}}
      </td>
      <td class="text-center dark-blue">
        {{ union.fullName }}
      </td>
      <td class="text-center dark-blue">
        {{ union.shortName }}
      </td>
      <td class="text-center dark-blue">
        {{ getFormattedColleges(union) }}
      </td>
      <td class="text-center dark-blue">
        <div *ngIf="union.logo.length > 0">
          <img src="{{union.logo}}" style="max-height: 30px;">
        </div>
      </td>
      <td class="text-center strong-green bold" *ngIf="union.file.length > 0; else noFile">
        Oui
      </td>
      <ng-template #noFile>
        <td class="text-center dark-blue">
          {{union.file}}
        </td>
      </ng-template>
      <td class="text-center dark-blue">
        <button *ngIf="!areUnionsValidated" class="bg-white pointer" style="border: none;" (click)="removeAtIndex(rowIndex)">
          <img src="assets/trash-gray-icon.svg" alt="edit" width="15px">
        </button>
      </td>
    </tr>
  </ng-template>
</p-table>
